import React, { Component } from "react";
import divider from "../images/divider.png";

export default class Divider extends Component {
  render() {
    const width = this.props.width;
    return (
      <p className="divider">
        <img
          style={{ width: (width && `${width}px`) || `` }}
          src={divider}
          alt=""
        />
      </p>
    );
  }
}
